import { useQuery } from '@tanstack/react-query';
import axios from 'config/axios';
import { ImageSpecification } from '../feed-images-types';

type Response = {
  imageSpecifications: ImageSpecification[];
};

async function getImageSpecifications(purposeId: number) {
  const response = await axios.get<Response>('GetImageSpecifications', {
    params: { purposeId },
  });

  return response.data.imageSpecifications;
}

const useImageSpecifications = (purposeId: number) =>
  useQuery<ImageSpecification[]>({
    queryKey: ['imageSpecifications', purposeId],
    queryFn: () => getImageSpecifications(purposeId),
    enabled: !!purposeId,
  });

export default useImageSpecifications;
